export const sayHello = name => `hello ${name}`;
export const newActivityTitle = () => 'Activity ' + new Date().getTime();

export const mockRecentActivities = [
  {
    createdAt: '2019-05-09T03:02:44.195Z',
    description: null,
    duration: 128,
    tags: [],
    title: 'Activity 1557370962430',
    updatedAt: '2019-05-09T03:02:44.195Z',
    _id: '5cd3985492b73f2fd03fc2bd'
  },
  {
    createdAt: '2019-05-09T03:02:44.195Z',
    description: null,
    duration: 128,
    tags: [],
    title: 'Activity 1557370962430',
    updatedAt: '2019-05-09T03:02:44.195Z',
    _id: '5cd3985492b73f2fd03fc2bd'
  },
];

export const handleErrorResponse = errRes => {
  
  let e = errRes.response;
  if (!e) {
    return errRes.config;
  }

  return {
    url: e.config.url,
    method: e.config.method,
    params: e.config.params,
    body: e.request
  };
}